import type { AppContextProps } from '@/app/context/index.ts';
import { useState } from 'react';
import { Locales } from '@/app/locales/types.ts';
import { getDefaultLocale } from '@/app/locales/utils.ts';
import { LocalStorageKeys } from '@/app/localStorage/types.ts';

type UseAppContext = () => AppContextProps;

export const useAppContext: UseAppContext = () => {
  const defaultLocale = getDefaultLocale();
  const [locale, setLocale] = useState<Locales>(defaultLocale);
  const [errorMessage, setErrorMessage] = useState<string>('');

  return {
    locale,
    setLocale: () => {
      const nexLocale = locale === Locales.RU ? Locales.KZ : Locales.RU;
      setLocale(nexLocale);
      localStorage.setItem(LocalStorageKeys.Locale, nexLocale);
    },
    message: errorMessage,
    setMessage: (message) => setErrorMessage(message),
  };
};
